export const buttonStyle = (label, className) => {
  const square = !label && 'aspect-square';
  return {
    outer: `flex flex-row justify-center gap-x-3 font-bold ${square} ${className}`,
    icon: 'my-auto',
    label: 'my-auto',
  };
};
